export const lineEq = (y2, y1, x2, x1, currentVal) => {
  // y = mx + b 
  var m = (y2 - y1) / (x2 - x1), b = y1 - m * x1;
  return m * currentVal + b;
}
  
export const lerp = (a, b, n) => (1 - n) * a + n * b

export const getRandomFloat = (min, max) => (Math.random() * (max - min) + min).toFixed(2)
